package fr.arcplex.sooner

object DefaultPlatformUtils : PlatformUtils {
    override val isTV: Boolean = false
}

interface PlatformUtils {
    val isTV: Boolean
}

expect fun getPlatformUtils(): PlatformUtils
